<template>
<div class="vliveExampleGuideCover">
    <div class="phone-model phone_model phone_model2">
        <div class="vlive-guide-cover">
            <!-- <img :src="vliveModel.guideCover.coverPicture.furl +'?'+vliveModel.guideCover.coverPicture.fsize" alt=""> -->
            <img :src="liveInfoData.posterurl.furl" alt="">
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'vliveExampleGuideCover',
    props: ['liveInfoData'],
    data() {
        return {
            timestamp: new Date().getTime() // 时间戳
        }
    },
    created() {
    },
    mounted() {},
    methods: {
        handleClick() {

        },
        ...mapActions([
            'setVliveModel'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'vliveModel'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveExampleGuideCover {
    .phone-model{
        .vlive-guide-cover{
            width: 318px;
            height: 512px;
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
    .phone_model2 {
        width: 340px!important;
        padding: 119px 42px 0 39px!important;
        .vlive-guide-cover{
            width: 266px;
            height: 430px;
        }
    }
}
</style>
